export var MenuPage;

(function (MenuPage) {
  MenuPage["LAYERS"] = "layers";
  MenuPage["SETTINGS"] = "settings";
  MenuPage["ABOUT"] = "about";
  MenuPage["USAGE"] = "usage";
  MenuPage["CHANGELOG"] = "changelog";
  MenuPage["EXPERIMENTS"] = "experiments";
})(MenuPage || (MenuPage = {}));

export * from "./types";